// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AccountCreate
 */
export interface AccountCreate {
  /**
   *
   */
  givenName: string;
  /**
   *
   */
  familyName: string;
  /**
   *
   */
  email: string;
  /**
   *
   */
  username: string;
  /**
   *
   */
  password: string;
  /**
   *
   */
  invitationId: string;
}

/**
 * Check if a given object implements the AccountCreate interface.
 */
export function instanceOfAccountCreate(value: object): value is AccountCreate {
  if (
    (!("givenName" in (value as Record<string, any>)) &&
      !("given_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["givenName"] === undefined &&
      (value as Record<string, any>)["given_name"] === undefined)
  )
    return false;
  if (
    (!("familyName" in (value as Record<string, any>)) &&
      !("family_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["familyName"] === undefined &&
      (value as Record<string, any>)["family_name"] === undefined)
  )
    return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  if (!("username" in value) || value["username"] === undefined) return false;
  if (!("password" in value) || value["password"] === undefined) return false;
  if (
    (!("invitationId" in (value as Record<string, any>)) &&
      !("invitation_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["invitationId"] === undefined &&
      (value as Record<string, any>)["invitation_id"] === undefined)
  )
    return false;
  return true;
}

export function AccountCreateFromJSON(json: any): AccountCreate {
  return AccountCreateFromJSONTyped(json, false);
}

export function AccountCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountCreate {
  if (json == null) {
    return json;
  }
  return {
    givenName: json["given_name"],
    familyName: json["family_name"],
    email: json["email"],
    username: json["username"],
    password: json["password"],
    invitationId: json["invitation_id"],
  };
}

export function AccountCreateToJSON(json: any): AccountCreate {
  return AccountCreateToJSONTyped(json, false);
}

export function AccountCreateToJSONTyped(
  value?: AccountCreate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    given_name: value["givenName"],
    family_name: value["familyName"],
    email: value["email"],
    username: value["username"],
    password: value["password"],
    invitation_id: value["invitationId"],
  };
}
